import orderBy from 'lodash/orderBy';
import type { Candidate } from '@axiom/validation';

type Props = Candidate['industries'];

export class CandidateIndustryModel {
  props: Props = [];

  constructor(props: Props) {
    this.props = props;
  }

  getDisplayableIndustries() {
    return (
      this.props?.filter(i => i.industryValue.toLowerCase() !== 'other') || []
    );
  }

  formatIndustries() {
    return orderBy(
      this.getDisplayableIndustries().map(
        (industry: NonNullable<Candidate['industries']>[number]) => ({
          ...industry,
          yearsOfExperience: Number.parseInt(industry.yearsOfExperience, 10),
        })
      ),
      ['yearsOfExperience', 'industryValue'],
      ['desc', 'asc']
    );
  }
}
